import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';
import { LayoutConfig } from '@spartacus/storefront';

@NgModule({
  declarations: [],
  imports: [
    ConfigModule.withConfig({
      layoutSlots: {
        header: null,
        KnBrProductDetailsPageTemplate: null,
      },
    } as LayoutConfig),

    ConfigModule.withConfig({
      layoutSlots: {
        header: {
          lg: {
            slots: ['SiteContext'],
          },
          slots: ['SiteContext'],
        },
        ErrorPageTemplate: {
          slots: ['TopContent', 'MiddleContent', 'BottomContent'],
        },
        CwtLoginPageTemplate: {
          slots: ['SiteTitle', 'LeftContentSlot'],
        },
        LandingPage2Template: {
          slots: ['Section1', 'Section2'],
        },
        CwtLandingPage2Template: {
          slots: ['Section1', 'Section3' ],
        },
        KnBrLandingPage2Template: {
          pageFold: 'Section2B',
          slots: ['Section1', 'Section1B', 'Section2A', 'Section2B', 'Section2C', 'Section3', 'Section4', 'Section5'],
        },
        CwtProductListPageTemplate: {
          slots: [ 'ProductLeftRefinements', 'ProductListSlot'],
        },
        CwtSearchResultsListPageTemplate: {
          slots: [ 'ProductLeftRefinements', 'SearchResultsListSlot'],
        },
        KnBrProductGridPageTemplate: {
          slots: ['BottomHeaderSlot', 'SearchBox', 'Section1', 'ProductLeftRefinements', 'ProductGridSlot'],
        },
        KnBrSearchResultsListPageTemplate: {
          slots: ['ProductLeftRefinements', 'SearchResultsListSlot'],
        },
        KnBrSearchResultsGridPageTemplate: {
          slots: ['SearchBox', 'Section1', 'ProductLeftRefinements', 'SearchResultsGridSlot'],
        },
        KnBrDraftOrderPageTemplate: {
          slots: ['TopContent', 'KnBrDraftOrderListActionBarSlot', 'BodyContent'],
        },
        KnBrDraftOrderCreatePageTemplate: {
          slots: ['BodyContent'],
        },
        CwtCartDetailPageTemplate: {
          slots: ['CwtMiniCartSlot', 'CwtShoppingCart', 'CwtCartProductOrderSummary','CwtEmptyCart']
        },
        KnBrQuoteCreatePageTemplate: {
          slots: ['BodyContent'],
        },
        KnBrQuoteDetailPageTemplate: {
          slots: ['KnBrQuoteHeaderSlot', 'KnBrQuoteItemsSlot', 'KnBrEmptyCartSlot'],
        },
        KnBrOrderConfirmationPageTemplate: {
          slots: ['BodyContent', 'SideContent'],
        },
        KnBrQuotePageTemplate: {
          slots: ['TopContent',  'BodyContent'],
        },
        KnBrProductDetailsPageTemplate: {
          lg: {
            pageFold: 'UpSelling',
          },
          pageFold: 'Summary',
          slots: [
            'BottomHeaderSlot',
            'Summary',
            'UpSelling',
            'CrossSelling',
            'ProductFeatures',
            'Tabs',
            'PlaceholderContentSlot',
          ],
        },

        CwtProductDetailsPageTemplate:{
          // 'BottomHeaderSlot'
          slots:['CwtSummary','CwtProductFeature','CwtTabs','CwtProductLiterature','CwtProductInstallation']
        },
            
        knBrQuoteSellerApproverTemplate: {
          slots: ['SiteLogo', 'SiteTitle', 'LeftContentSlot'],
        },
        KnBrCustomer360PageTemplate: {
          slots: ['TopContent', 'MiddleContent', 'BottomContent', 'BodyContent'],
        },
        CwtOrderHistoryPageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        CwtOrderDetailsPageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        CwtReturnHistoryPageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        CwtReturnDetailsPageTemplate: {
          slots: ['BodyContent'],
        },
        CwtInvoiceDetailsPageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        CwtAccountDetailsPageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        CarlisleShippingListingPageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        CwtInvoiceListPageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        KnBrAddressBookPageTemplate: {
          slots: ['BodyContent'],
        },
        KnBrFactSheetPageTemplate: {
          slots: ['TopContent', 'MiddleContent'],
        },
        KnBrOrderImportPageTemplate: {
          slots: ['BodyContent'],
        },
        KnBrQuickOrderPageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        KnBrOrderFormsPageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        KnBrQuickEntryPageTemplate: {
          slots: ['TopContent', 'BodyContent'],
        },
        KnBrPurchasingAgentPageTemplate: {
          slots: ['Section2'],
        },
        KnBrServiceTicketsPageTemplate: {
          slots: ['Section1'],
        },
        AccountPageTemplate: {
           slots: ['BodyContent'],
        },
        KnBrRegistrationPageTemplate: {
          slots: ['BodyContent'],
        },
        NACPageTemplate: {
          slots: ['TopContent', 'BottomContent'],
        },
        KnBrMarketCentrePageTemplate: {
          slots: ['LeftContentSlot', 'RightContentSlot', 'MiddleLeftContentSlot'],
        },
        ContentPage1Template: {
          slots: ['Section2A','Section1'],
        },
        CompanyPageTemplate: {
          slots: ['BodyContent'],
        },
        CarlisleCaseCreationPageTemplate: {
          slots: ['BodyContent']
        },
        CarlisleCaseListPageTemplate: {
          slots: ['BodyContent']
        },
        CarlisleCaseDetailPageTemplate: {
          slots: ['BodyContentCaseDetail']
        },
        CwtRegistrationPageTemplate: {
          slots: ['CwtBodyContent']
        },
         CwtMultiStepCheckoutSummaryPageTemplate:{
          slots:[],
        }, 
        CwtOrderConfirmationPageTemplate:{
          slots:['BodyContent']
        },
        CwtSupportPageTemplate: {
          slots:['CwtBodyContent']
        },
        CwtLogoutPageTemplate: {
          slots: ['CwtSection1']
        }
        // CwtCartDetailPageTemplate: {
        //   slots: ['MiniCart', 'CwtShoppingCart', 'CwtCartProductOrderSummary']
        //   // slots: ['CwtMiniCartSlot', 'CwtShoppingCart', 'CwtCartProductOrderSummary']
        // }
      },
    } as LayoutConfig),
  ],
})
export class KnBrLayoutConfigModule {}
